import { useSelector } from "react-redux";
import { StringService, _ } from "src/services";
import { Packages } from "src/store";

export const PaymanetInfo: React.FC<{ showResult?: boolean }> = ({ showResult }) => {

    //#region dependencies

    const packages: Packages = useSelector((state: any) => state.PackagesState);

    //#endregion

    const renderContent = () => {
        if (packages.loading && !packages.order) return (
            <>
                <div className="invoice-row w-100 relative">
                    <div className="shimmer absolute dark"></div>
                </div>
                <div className="invoice-row w-100 relative">
                    <div className="shimmer absolute dark"></div>
                </div>
                <div className="invoice-row w-100 relative">
                    <div className="shimmer absolute dark"></div>
                </div>
                <div className="invoice-row w-100 relative">
                    <div className="shimmer absolute dark"></div>
                </div>
            </>
        );

        if (!packages.order) return null;

        const { amount, payableTaxAmount, tax, taxAmount, discount, orderNumber } = packages.order;


        return (
            <>
                <div className="invoice-row w-100">
                    <span className="invoice-title float-right">{_("orderNumber")}</span>
                    <span className="invoice-value float-left">{orderNumber}</span>
                </div>
                <div className="invoice-row w-100">
                    <span className="invoice-title float-right">{_("packagePrice")}</span>
                    <span className="invoice-value float-left">{StringService.toPrice(amount)} {_("currency")}</span>
                </div>
                <div className="invoice-row w-100">
                    <span className="invoice-title float-right">{_("taxAmount")} ({tax}%)</span>
                    <span className="invoice-value float-left">{StringService.toPrice(taxAmount)} {_("currency")}</span>
                </div>
                {
                    discount > 0 &&
                    <div className="invoice-row w-100 red-fcolor">
                        <span className="invoice-title float-right">{_("discount")}</span>
                        <span className="invoice-value float-left">{StringService.toPrice(discount)} {_("currency")}</span>
                    </div>
                }
                <div className="invoice-row w-100 green-fcolor bold-fsize">
                    <span className="invoice-title float-right">{_("payableTaxAmount")}</span>
                    <span className="invoice-value float-left">{StringService.toPrice(payableTaxAmount)} {_("currency")}</span>
                </div>
            </>
        );
    };

    return (
        <div className="payment-bill-info d-flex flex-column">
            <div className="payment-box__invoice d-flex flex-column">
                {renderContent()}
            </div>
        </div>
    );
};